import { render, staticRenderFns } from "./SummaryButton.vue?vue&type=template&id=63a3f76f&scoped=true"
import script from "./SummaryButton.vue?vue&type=script&lang=ts"
export * from "./SummaryButton.vue?vue&type=script&lang=ts"
import style0 from "./SummaryButton.vue?vue&type=style&index=0&id=63a3f76f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3f76f",
  null
  
)

export default component.exports